export enum UserInteractionEvents {
  Touchstart = 'touchstart',
  Mousedown = 'mousedown',
  Mousemove = 'mousemove',
  Keydown = 'keydown',
  Scroll = 'scroll',
}
